<div *ngIf="user_type === 200">
	<div class="p-card">
		<div class="p-3">
			<h2 class="pb-3">Translation Management ({{selectedLang}})</h2>
			<!-- Add New Translation Form -->
			<form (ngSubmit)="addTranslation()" class="row g-4">
				<div class="col-12 col-lg-4">
					<h6>Page</h6>
					<input pInputText [(ngModel)]="newTranslation.page" name="page" id="page" required />
				</div>
				<div class="col-12 col-lg-4">
					<h6>Key</h6>
					<input pInputText [(ngModel)]="newTranslation.key" name="key" id="key" required />
				</div>
				<div class="col-12 col-lg-4">
					<h6>Value</h6>
					<input pInputText [(ngModel)]="newTranslation.value" name="value" id="value" required />
				</div>
				<div class="col-12">
					<button pButton type="submit" label="Add Translation" class="p-button-success"></button>
				</div>
			</form>
		</div>
		<div *ngFor="let page of getPages()">
			<h3 class="px-3">{{ page }}</h3>
			<p-table [value]="getTranslationKeys(page)" [responsive]="true">
				<ng-template pTemplate="header">
					<tr>
						<th>Key</th>
						<th>Translation</th>
						<th>Actions</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-key>
					<tr>
						<td>{{ key }}</td>
						<td>
							<input pInputText [(ngModel)]="translations[page][key]" [name]="page + '_' + key" />
						</td>
						<td>
							<button pButton type="button" icon="pi pi-save" class="p-button-text p-button-sm"
								(click)="updateTranslation(page, key)" label="Save"></button>
							<button pButton type="button" icon="pi pi-trash"
								class="p-button-danger p-button-text p-button-sm" (click)="removeTranslation(page, key)"
								style="margin-left:5px;" label="Delete"></button>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>
<div *ngIf="user_type !== 200">
	<p-message severity="warn" text="You do not have access to this page."></p-message>
</div>